import { motion } from "framer-motion";
import howWork from "@/assets/landing/how_work.webp";
import BrandMark from "./ui/brandMark";
import Reveal from "./ui/reveal";

const steps = [
  {
    title: "Crea tu usuario",
    description:
      "Identidad Digital. Accede a tu entorno de control personalizado en segundos.",
    top: 0,
    left: 0,
  },
  {
    title: "Escoge tus automatizaciones",
    description:
      "Selección Estratégica. Explora nuestra biblioteca de plantillas lógicas o diseña desde cero.",
    top: 24,
    left: 18,
  },
  {
    title: "Ejecuta tu proceso",
    description:
      "Despliegue Instantáneo. Activa tus flujos y observa cómo la infraestructura cobra vida.",
    top: 46,
    left: 34,
  },
  {
    title: "Conecta tu integración",
    description:
      "Escalabilidad Total. Vincula tus herramientas y expande el alcance de tu red neural.",
    top: 72,
    left: 8,
  },
];

export default function HowItWorks() {
  return (
    <section className="relative overflow-hidden bg-nodric-ink">
      {/* soft blue-to-lilac glow behind the visual, not a hard color block */}
      <div
        aria-hidden
        className="absolute -top-32 -left-40 h-120 w-120 rounded-full bg-linear-to-br from-nodric-blue via-[#5b8dfb] to-[#d9c7f0] opacity-60 blur-[100px] lg:h-175 lg:w-175"
      />
      <BrandMark className="absolute top-[10%] right-[6%] h-96 w-96 bg-white/5 lg:h-188 lg:w-248" />

      <div className="relative z-10 grid lg:grid-cols-[38%_1fr]">
        {/* Visual column */}
        <div className="relative min-h-80 lg:min-h-205">
          <img
            src={howWork}
            alt=""
            className="absolute bottom-0 left-1/2 h-full w-auto max-w-none -translate-x-1/2 object-contain object-bottom"
          />
          <Reveal
            direction="right"
            className="relative z-10 px-6 pt-16 md:px-12 lg:pt-24"
          >
            <h2 className="font-display text-3xl font-medium tracking-[0.08em] text-white md:text-5xl">
              ¿Cómo funciona?
            </h2>
          </Reveal>
        </div>

        {/* Steps column */}
        <div className="relative px-6 py-16 md:px-16 lg:py-28">
          {/* mobile/tablet: simple stacked list */}
          <div className="flex flex-col gap-12 lg:hidden">
            {steps.map((step, index) => (
              <motion.div
                key={step.title}
                initial={{ opacity: 0, x: 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{
                  duration: 0.6,
                  delay: index * 0.08,
                  ease: [0.22, 1, 0.36, 1],
                }}
                className="relative max-w-md"
              >
                <span
                  aria-hidden
                  className="absolute top-3 -left-4 h-2.5 w-2.5 rounded-full bg-nodric-blue"
                />
                <h3 className="font-display text-2xl leading-tight font-medium tracking-[0.06em] text-white md:text-3xl">
                  {step.title}
                </h3>
                <p className="font-body mt-3 text-[13px] leading-relaxed text-white/65 md:text-sm">
                  {step.description}
                </p>
              </motion.div>
            ))}
          </div>

          {/* desktop: staircase layout with elbow dashed connectors */}
          <div className="relative hidden lg:block lg:min-h-140">
            {steps.slice(1).map((step, i) => {
              const prev = steps[i];
              return (
                <div key={step.title} aria-hidden>
                  <div
                    className="absolute w-px border-l border-dashed border-nodric-blue/40"
                    style={{
                      left: `${prev.left}%`,
                      top: `${prev.top}%`,
                      height: `${step.top - prev.top}%`,
                    }}
                  />
                  <div
                    className="absolute h-px border-t border-dashed border-nodric-blue/40"
                    style={{
                      left: `${prev.left}%`,
                      top: `${step.top}%`,
                      width: `${step.left - prev.left}%`,
                    }}
                  />
                </div>
              );
            })}

            {steps.map((step, index) => (
              <motion.div
                key={step.title}
                initial={{ opacity: 0, x: 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{
                  duration: 0.6,
                  delay: index * 0.08,
                  ease: [0.22, 1, 0.36, 1],
                }}
                className="absolute max-w-60"
                style={{ top: `${step.top}%`, left: `${step.left}%` }}
              >
                <span
                  aria-hidden
                  className="absolute top-3 -left-6 h-2.5 w-2.5 rounded-full bg-nodric-blue"
                />
                <h3 className="font-display text-xl leading-tight font-medium tracking-[0.06em] text-white md:text-2xl">
                  {step.title}
                </h3>
                <p className="font-body mt-3 text-[13px] leading-relaxed text-white/65">
                  {step.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
